import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import { VpnKey, People } from "@material-ui/icons";
import Button from "./../components/CustomButtons/Button";
import CustomInput from "./../components/CustomInput/CustomInput";
import GridContainer from "./../components/Grid/GridContainer.js";
import GridItem from "./../components/Grid/GridItem.js";
import Card from "./../components/Card/Card.js";
import CardBody from "./../components/Card/CardBody.js";
import CardHeader from "./../components/Card/CardHeader.js";
import CardFooter from "./../components/Card/CardFooter.js";
import styles from "../assets/style/login";
import { authAPI } from "../services/AuthService";
import { AppContext } from "../contexts/appContext";
import Swal from "sweetalert2";

const useStyles = makeStyles(styles);

const Login = (props) => {
  const { updateLogin } = useContext(AppContext);
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  let history = useHistory();
  const LoginFunction = (e) => {
    e.preventDefault();

    setLoading(true);
    authAPI
      .Login({ username, password })
      .then((res) => {
        if (res.status == 200) {
          localStorage.setItem("Token", res.message);
          setLoading(false);
          updateLogin(true);
          setUsername("");
          setPassword("");
          setTimeout(() => {
            history.push("/");
          }, 300);
        } else {
          setLoading(false);
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 3000,
        });
      });
  };

  useEffect(() => {
    document.title = "Com7 Merchandise - Login";
    let mytimeout = setTimeout(() => {
      setCardAnimation("");
    }, 700);
    return () => {
      clearTimeout(mytimeout);
      setUsername("");
      setPassword("");
    };
  }, []);

  const classes = useStyles();

  return (
    <div onSubmit={LoginFunction}>
      <div
        className={classes.pageHeader}
        style={{
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card
                className={classes[cardAnimaton]}
                style={{ borderRadius: "10px" }}
              >
                <form className={classes.form}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h3>Merchandise Messenger</h3>
                  </CardHeader>
                  <p className={classes.divider}>เข้าสู่ระบบเพื่อเริ่มใช้งาน</p>
                  <CardBody>
                    <CustomInput
                      values={username}
                      setValues={setUsername}
                      labelText="Username..."
                      id="username"
                      type="text"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        endAdornment: (
                          <InputAdornment position="end">
                            <People className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      values={password}
                      setValues={setPassword}
                      labelText="Password..."
                      id="password"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      type="password"
                      inputProps={{
                        type: "password",
                        endAdornment: (
                          <InputAdornment position="end">
                            <VpnKey className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </CardBody>
                  <CardFooter
                    className={classes.cardFooter}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <Button
                      className={classes.cardButton}
                      simple
                      type="submit"
                      color={`${
                        username == "" || password == "" ? "danger" : "primary"
                      }`}
                      style={{
                        borderRadius: "15px",
                        boxShadow: `0 5px 5px -50px ${
                          username == "" || password == ""
                            ? "lightgray"
                            : "#6ab23a"
                        }, 0 2px 15px -5px ${
                          username == "" || password == ""
                            ? "lightgray"
                            : "#6ab23a"
                        },0 12px 20px -10px ${
                          username == "" || password == ""
                            ? "lightgray"
                            : "#6ab23a"
                        }`,
                      }}
                      size="lg"
                      disabled={username == "" || password == "" || loading}
                      onClick={LoginFunction}
                    >
                      เข้าสู่ระบบ
                    </Button>
                    <Button
                      className={classes.cardButton}
                      simple
                      type="button"
                      color={"primary"}
                      size="lg"
                      disabled={loading}
                      onClick={() => history.push("/forget-password")}
                    >
                      ลืมรหัสผ่าน
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
};
export default Login;
